export const currentUserSelector = (state) => state.compteReducers

export const detailsCurrentUserSelector = (state) => state.detailsUserCurrent

export const selectedDiscussion = (state) => state.chatReducers.selectedDiscussion

export const isConnected = (state) => state.compteReducers.isConnected